// components/BarChart.tsx
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ProductData {
  productName: string;
  totalUnitsSold: number;
  totalRevenue: number;
  productImage: string;
  productDescription: string | null;
}

interface BarChartProps {
  data: ProductData[];
}

const YearVisuals: React.FC<BarChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map((item: any) => item.date),
    datasets: [
      {
        label: "Total Sales Amount",
        data: data.map((item: any) => item.totalSalesAmount / 100),
        backgroundColor: "#FF5001",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      // title: {
      //   display: true,
      //   text: "Units Sold per Product",
      // },
    },
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default YearVisuals;
